import {useRef, useState} from "react";
import { uniqueId } from "lodash";
import toast from "react-hot-toast";

export default function AudioUpload({isAudioRecordingStarted, recordedDataHandler, recordingData, allowedSampleFile }) {
    const inputRef = useRef(null);
    const [isDragOver, setIsDragOver] = useState(false);

    const handleFiles = (files) => {
        let validFileCount = 0;

        Array.from(files).forEach((file) => {
            if(validFileCount === allowedSampleFile)
                return;

            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (fileExtension !== 'mp3' && fileExtension !== 'wav') {
                toast.error(`"${file.name}" is not a supported file type. Only MP3 and WAV are allowed.`);
                return;
            }

            if (file.size > 20 * 1024 * 1024) {
                toast.error(`"${file.name}" exceeds the 20MB limit.`);
                return;
            }

            if (!file.type.startsWith("audio/")) {
                toast.error(`"${file.name}" is not a valid audio file.`);
                return;
            }

            const audio = document.createElement("audio");
            audio.src = URL.createObjectURL(file);

            audio.addEventListener("loadedmetadata", () => {
                const duration = audio.duration;

                if (duration < 10 || duration > 60) {
                    toast.error(`"${file.name}" must be between 10s and 60s.`);
                    return;
                }

                recordedDataHandler({
                    id: uniqueId(),
                    blob: file,
                    name: file.name,
                    time: duration?.toFixed(0),
                    size: (file.size / (1024 * 1024))?.toFixed(2)
                });
            });

            validFileCount += 1;
        });
    };

    const handleDrop = (e) => {
        e.preventDefault();
        handleFiles(e.dataTransfer.files);
        setIsDragOver(false);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = () => {
        setIsDragOver(false);
    };

    const triggerFileInput = () => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };

    return (
        <div className="w-[55%] relative">
            <input
                ref={inputRef}
                type="file"
                accept=".mp3, .wav"
                multiple
                className="hidden"
                onChange={(e) => {
                    const files = e.target.files;
                    if (files.length > 0) {
                        handleFiles(files);
                        e.target.value = null;
                    }
                }}
            />

            <div
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onClick={triggerFileInput}
                className={`w-full h-full flex-1 flex hover:border-[#8a4af3] flex-col items-center justify-center border-2 border-dashed bg-[#fcfcfd] p-6 rounded-xl cursor-pointer transition-colors duration-300 ${
                    isDragOver ? "border-[#8a4af3]" : "border-gray-300"
                }`}
            >
                <img
                    className="w-[40px] h-[40px] mb-[10px]"
                    src="/images/icon-audio-drag-and-drop.png"
                    alt="audio-drag-and-drop"
                />
                <p className="font-medium text-sm">Add or drop audio file</p>
                <p className="text-[10px] text-gray-400 pt-0.5">Up to 20MB each ( MP3 / WAV )</p>
            </div>

            {(recordingData?.length >= allowedSampleFile || isAudioRecordingStarted) && (
                <div className="w-full h-full rounded-xl border-gray-300 bg-gray-50 opacity-60 absolute top-0 left-0 z-50"></div>
            )}
        </div>
    );
}
